import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'

export const st8LaunchGameService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/st8/launch', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const st8WithdrawService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/st8/withdraw', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
